import { FuelButton, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import React from 'react';

export const Error: React.FC<{ refetch: () => void }> = ({ refetch }) => (
  <FuelFlex
    defaultProps={{
      display: 'flex',
      flexDirection: 'column',
      gap: 'km4',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
    }}
    testId="last-consultation-error"
  >
    <FuelTypography color="neutral-default" weight="medium">
      Falha ao carregar as consultas e cadastros.
    </FuelTypography>

    <FuelButton variant="tertiary" size="small" trailingIcon="reload" trailingIconStyle="outlined" onClick={refetch}>
      Tentar novamente
    </FuelButton>
  </FuelFlex>
);
